(function () {
  function initSection(root) {
    if (!root || root.dataset.etProductInit === '1') return;
    root.dataset.etProductInit = '1';

    var mainSwiperEl = root.querySelector('[data-main]');
    var thumbsSwiperEl = root.querySelector('[data-thumbs]');
    var paginationEl = root.querySelector('[data-pagination]');
    var nextBtn = root.querySelector('[data-next]');
    var prevBtn = root.querySelector('[data-prev]');
    var variantInput = root.querySelector('[data-variant-input]');
    var titleEl = root.querySelector('[data-product-title]');
    var priceEl = root.querySelector('[data-product-price]');
    var colorNameEl = root.querySelector('[data-color-name]');

    /* -------- Parse products JSON (1 main + N product blocks) -------- */
    var products = [];
    var dataEl = root.querySelector('[data-products-json]');
    if (dataEl) {
      try {
        products = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        products = [];
      }
    }

    /* -------- Build slide HTML for a product -------- */
    function buildMainSlides(p) {
      if (!p.images || !p.images.length) return '';
      return p.images.map(function (img) {
        return (
          '<div class="swiper-slide et-listicle-product__slide">' +
            '<img src="' + img.src + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" ' +
              'loading="lazy" class="et-listicle-product__slide-image">' +
          '</div>'
        );
      }).join('');
    }
    function buildThumbSlides(p) {
      if (!p.images || !p.images.length) return '';
      return p.images.map(function (img) {
        return (
          '<div class="swiper-slide et-listicle-product__thumb">' +
            '<img src="' + img.thumb + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '" ' +
              'loading="lazy" class="et-listicle-product__thumb-image">' +
          '</div>'
        );
      }).join('');
    }

    /* -------- Swiper init (Thumbs + Navigation), called on init AND switch -------- */
    function initSwipers() {
      if (!window.Swiper || !mainSwiperEl) return;

      if (root._thumbsSwiper) { try { root._thumbsSwiper.destroy(true, true); } catch (e) {} root._thumbsSwiper = null; }
      if (root._mainSwiper) { try { root._mainSwiper.destroy(true, true); } catch (e) {} root._mainSwiper = null; }

      var slideCount = mainSwiperEl.querySelectorAll('.swiper-slide').length;

      var thumbsSwiper = null;
      if (thumbsSwiperEl) {
        thumbsSwiper = new window.Swiper(thumbsSwiperEl, {
          direction: 'vertical',
          slidesPerView: 3,
          spaceBetween: 8,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true
        });
        root._thumbsSwiper = thumbsSwiper;
      }

      var mainOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextBtn || null,
          prevEl: prevBtn || null,
          disabledClass: 'swiper-button-disabled'
        }
      };
      if (thumbsSwiper) mainOptions.thumbs = { swiper: thumbsSwiper };
      if (paginationEl) mainOptions.pagination = { el: paginationEl, clickable: true };

      root._mainSwiper = new window.Swiper(mainSwiperEl, mainOptions);
    }

    initSwipers();

    /* -------- Product switching (click on swatch) -------- */
    function switchProduct(idx) {
      if (idx < 0 || idx >= products.length) return;
      var p = products[idx];

      var thumbsWrapper = thumbsSwiperEl ? thumbsSwiperEl.querySelector('.swiper-wrapper') : null;
      var mainWrapper = mainSwiperEl ? mainSwiperEl.querySelector('.swiper-wrapper') : null;

      if (thumbsWrapper) {
        thumbsWrapper.style.transform = '';
        thumbsWrapper.innerHTML = buildThumbSlides(p);
      }
      if (mainWrapper) {
        mainWrapper.style.transform = '';
        mainWrapper.innerHTML = buildMainSlides(p);
      }

      if (titleEl) titleEl.textContent = p.title;
      if (priceEl) priceEl.textContent = p.price;
      if (colorNameEl) colorNameEl.textContent = p.color_name;
      if (variantInput && p.variant_id) variantInput.value = p.variant_id;

      root.querySelectorAll('[data-product-index]').forEach(function (btn) {
        var isSel = btn.dataset.productIndex === String(idx);
        btn.classList.toggle('selected', isSel);
        var imgWrap = btn.querySelector('.variant-image-wrapper');
        if (imgWrap) imgWrap.classList.toggle('selected', isSel);
      });

      initSwipers();
    }

    root.querySelectorAll('[data-product-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.productIndex, 10);
        if (!isNaN(idx)) switchProduct(idx);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="et-listicle-product"]').forEach(initSection);
  }

  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }
    var attempts = 0;
    var iv = setInterval(function () {
      attempts += 1;
      if (window.Swiper) {
        clearInterval(iv);
        cb();
      } else if (attempts > 100) {
        clearInterval(iv);
        cb(); /* run anyway — gallery will be static but variant/CTA logic still works */
      }
    }, 50);
  }

  function boot() {
    whenSwiperReady(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="et-listicle-product"]');
    if (root) {
      whenSwiperReady(function () { initSection(root); });
    }
  });
})();
